/**
 * @generated SignedSource<<3cb866b8b9890f6714930a377f6adaca>>
 * @relayHash 9148b8df3c6fffab37766707e9d9d0b2
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9148b8df3c6fffab37766707e9d9d0b2

import { ConcreteRequest } from 'relay-runtime';
export type externalAssistanceDrawerQuery$variables = {
  id: string;
};
export type externalAssistanceDrawerQuery$data = {
  readonly ch_externalAssistanceById: {
    readonly reason: string;
  } | null;
};
export type externalAssistanceDrawerQuery = {
  response: externalAssistanceDrawerQuery$data;
  variables: externalAssistanceDrawerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reason",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "externalAssistanceDrawerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ch_ExternalAssistance",
        "kind": "LinkedField",
        "name": "ch_externalAssistanceById",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "externalAssistanceDrawerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ch_ExternalAssistance",
        "kind": "LinkedField",
        "name": "ch_externalAssistanceById",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "9148b8df3c6fffab37766707e9d9d0b2",
    "metadata": {},
    "name": "externalAssistanceDrawerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9b797b719c9f5d9ae0942e7feb810c4f";

export default node;
